// @flow

import * as React from 'react';
import styles from './OverflowUIList.css';

type Props = {|
  /** children must be one or an array of `OverflowUIListItem`s */
  children?: React$Element<any> | React$Element<any>[],
  /** `close` prop is passed in by OverflowUI when this OverflowUIList is a child of said OverflowUI. Calling this function will close the OverflowUI popover */
  close: () => void,
|};

/**
 * OverflowUIList is a component to be used as a child of OverflowUI, to represent a list of menu items in the overflow menu. See OverflowUI.story.jsx
 * */
const OverflowUIList = ({ children, close }: Props) => (
  <ul className={styles.list}>
    {children
      ? React.Children.map(children, (child: ?React.Element<any>) =>
          child ? React.cloneElement(child, { close }) : child,
        )
      : null}
  </ul>
);

OverflowUIList.defaultProps = {
  children: undefined,
  close: () => {},
};

export default OverflowUIList;
